import { Button } from '../../../../components/ui/Button'
import { THEMES } from './eyesPreviewCatalog'
import { ACCENT_PRESETS, LIBRARY_MOODS, shortenTag, ossGroupDisplayName, repoNameFromUrl } from './eyesPreviewData'
import { Search, Sparkles } from 'lucide-react'
import DeviceScreenPreview, { emojiFromEmotion } from '../../../../components/DeviceScreenPreview'
import { emotionLabelEntry, normalizeEmotion } from '../../../../utils/emotion'
import { EyesDetailsModal } from './EyesDetailsModal'
import { FoilParallaxCard } from './FoilParallaxCard'

export function EyesPreviewView(props) {
  const { accent, auditGroupIndex, auditMode, cardScale, cards, detailsActiveGroup,
    detailsProduct, extraLibraryProducts, inLibrary, libraryEmotion,
    libraryFilteredGroups, libraryGroupSimilar, libraryQuery, openCompareFromModal,
    ossGroups, pinnedLibraryProducts, poke, renderLibraryProduct, selectOssGroup,
    selectTheme, selectedProject, selectedProjects, setDetailsKey,
    setDetailsSubKey, setPoke, stepAuditGroup, theme, themeLabelById, tx,
    updateAccent, updateLibraryEmotion, updateLibraryGroupSimilar,
    updateLibraryQuery, updateScale, updateView, variant, view } = props
  return (
    <div className="space-y-6">
      <EyesDetailsModal
        detailsProduct={detailsProduct}
        setDetailsKey={setDetailsKey}
        setDetailsSubKey={setDetailsSubKey}
        detailsActiveGroup={detailsActiveGroup}
        tx={tx}
        openCompareFromModal={openCompareFromModal}
        poke={poke}
        accent={accent}
        themeLabelById={themeLabelById}
        cardScale={cardScale}
        libraryEmotion={libraryEmotion}
        selectOssGroup={selectOssGroup}
        updateLibraryEmotion={updateLibraryEmotion}
      />

      <div className="rounded-3xl border-2 border-brand-textDark/10 bg-brand-bg backdrop-blur-md shadow-sm dark:bg-slate-900/80 dark:border-slate-800">
        <div className="p-5 flex flex-col gap-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 rounded-2xl bg-brand-yellow/80 border border-brand-yellowDark/70 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-brand-textDark dark:text-slate-900" />
              </span>
		              <div className="min-w-0">
		                <div className="text-brand-textDark dark:text-slate-100 font-extrabold text-lg">
                      {auditMode
                        ? tx({ zh: '眼睛表情预览', en: 'Eyes Preview' })
                        : view === 'library'
                          ? tx({ zh: '眼睛库', en: 'Eyes Library' })
                          : tx({ zh: '眼睛表情对比', en: 'Eyes Compare' })}
                    </div>
		                <div className="text-brand-text dark:text-slate-300 text-xs font-bold">
		                  {tx({
                        zh: '单独页面：只看渲染效果，不接设备',
                        en: 'Standalone page: render preview only (no device)',
                      })}
		                </div>
                    {auditMode ? (
                      <div className="mt-1 inline-flex items-center gap-2 text-[11px] font-black text-brand-textDark/80 dark:text-slate-200">
                        <span className="px-2 py-1 rounded-full bg-brand-yellow/70 border border-brand-yellowDark/60 text-brand-textDark">AUDIT</span>
                        <span>{tx({ zh: '固定 4 张卡片用于对比', en: 'Fixed 4 cards for comparison' })}</span>
                      </div>
                    ) : null}
		              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              {!auditMode ? (
                <>
                  <Button onClick={() => updateView('library')} variant={view === 'library' ? 'secondary' : 'neutral'} size="sm">
                    {tx({ zh: '库', en: 'Library' })}
                  </Button>
                  <Button onClick={() => updateView('compare')} variant={view === 'compare' ? 'secondary' : 'neutral'} size="sm">
                    {tx({ zh: '对比', en: 'Compare' })}
                  </Button>
                </>
              ) : null}

              {!inLibrary ? (
                <>
                  {THEMES.map((t) => (
                    <button
                      key={t.id}
                      type="button"
                      onClick={() => selectTheme(t.id)}
                      className={`px-3 py-2 rounded-2xl text-xs font-extrabold border transition-colors ${
                        theme === t.id
                          ? 'bg-brand-yellow text-brand-textDark border-brand-yellowDark shadow-[0_3px_0_#E5BC2E] dark:bg-brand-yellow dark:text-brand-textDark dark:border-brand-yellowDark'
                          : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                      }`}
                    >
                      {tx(t.label)}
                    </button>
                  ))}
                </>
              ) : null}
	            </div>
	          </div>

            {inLibrary ? (
              <>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '搜索', en: 'Search' })}</span>
                  <div className="relative flex-1 min-w-[220px]">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-brand-text/70 dark:text-slate-400" />
                    <input
                      value={libraryQuery}
                      onChange={(e) => updateLibraryQuery(e.target.value)}
                      placeholder={tx({ zh: '按名称/仓库过滤…', en: 'Filter by name/repo…' })}
                      className="w-full pl-9 pr-3 py-2.5 rounded-2xl border border-brand-textDark/10 bg-white text-sm font-bold text-brand-textDark outline-none placeholder:text-brand-text/60 focus:border-brand-yellowDark focus:ring-2 focus:ring-brand-yellow/40 transition-shadow dark:bg-slate-950 dark:border-slate-800 dark:text-slate-100 dark:placeholder:text-slate-400"
                    />
                  </div>
                  <span className="text-[11px] font-black text-brand-text dark:text-slate-300 tabular-nums">
                    {libraryFilteredGroups.length}/{ossGroups.length}
                  </span>
                </div>

                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '心情', en: 'Mood' })}</span>
                  <div className="flex flex-wrap gap-2">
                    {LIBRARY_MOODS.map((m) => {
                      const active = normalizeEmotion(libraryEmotion) === normalizeEmotion(m)
                      return (
                        <button
                          key={m}
                          type="button"
                          onClick={() => updateLibraryEmotion(m)}
                          className={`px-3 py-2 rounded-2xl text-xs font-extrabold border transition-colors ${
                            active
                              ? 'bg-brand-yellow text-brand-textDark border-brand-yellowDark shadow-[0_3px_0_#E5BC2E] dark:bg-brand-yellow dark:text-brand-textDark dark:border-brand-yellowDark'
                              : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                          }`}
                        >
                          <span className="mr-1">{emojiFromEmotion(m)}</span>
                          {tx(emotionLabelEntry(m))}
                        </button>
                      )
                    })}
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '去重', en: 'Dedupe' })}</span>
                  <button
                    type="button"
                    onClick={() => updateLibraryGroupSimilar(!libraryGroupSimilar)}
                    className={`px-3 py-2 rounded-2xl text-xs font-extrabold border transition-colors ${
                      libraryGroupSimilar
                        ? 'bg-brand-textDark text-white border-brand-textDark dark:bg-slate-100 dark:text-slate-900 dark:border-slate-100'
                        : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                    }`}
                    title={tx({ zh: '把相近的样式合并到同一卡片', en: 'Group similar styles into one card' })}
                  >
                    {libraryGroupSimilar ? tx({ zh: '已合并（推荐）', en: 'Grouped (recommended)' }) : tx({ zh: '显示全部', en: 'Show all' })}
                  </button>
                </div>
              </>
            ) : (
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">OSS</span>
                {ossGroups.map((g) => {
                  const active = g.theme === theme && (g.variant || '') === (variant || '')
                  const tag = shortenTag(ossGroupDisplayName(g), 18)
                  const count = Array.isArray(g.projects) ? g.projects.length : 0
                  const title = (g.projects || []).map((p) => `${p.label}\n${p.repo}`).join('\n\n')
                  return (
                    <div key={`${g.theme}:${g.variant || 'default'}`} className="relative group inline-flex">
                      <button
                        type="button"
                        onClick={() => selectOssGroup(g)}
                        className={`px-3 py-2 rounded-2xl text-xs font-extrabold border transition-colors ${
                          active
                            ? 'bg-brand-textDark text-white border-brand-textDark dark:bg-slate-100 dark:text-slate-900 dark:border-slate-100'
                            : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                        } whitespace-nowrap`}
                        title={title}
                      >
                        <span className="inline-flex items-center gap-2">
                          <span>{tag}</span>
                          {count > 1 ? (
                            <span
                              className={`px-1.5 py-0.5 rounded-full text-[10px] font-black ${
                                active ? 'bg-white/15 text-white' : 'bg-brand-bg text-brand-textDark/80 dark:bg-slate-800 dark:text-slate-200'
                              }`}
                            >
                              ×{count}
                            </span>
                          ) : null}
                        </span>
                      </button>

                      <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-2 -translate-y-full z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                        <div className="max-w-[320px] rounded-2xl bg-slate-950 text-white text-[11px] font-bold px-3 py-2 shadow-[0_12px_30px_rgba(0,0,0,0.28)] border border-white/10">
                          <div className="font-extrabold">{tag}</div>
                          <div className="text-white/70">
                            {(g.projects || []).slice(0, 4).map((p) => (
                              <div key={p.id} className="break-all">
                                {p.repo}
                              </div>
                            ))}
                            {count > 4 ? <div className="text-white/50">… (+{count - 4})</div> : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
                {selectedProject ? (
                  <a
                    href={selectedProject.repo}
                    target="_blank"
                    rel="noreferrer"
                    className="ml-auto text-xs font-extrabold text-brand-text hover:text-brand-textDark underline underline-offset-4 dark:text-slate-300 dark:hover:text-slate-100"
                    title={selectedProjects.map((p) => p.repo).join('\n')}
                  >
                    {selectedProjects.length > 1 ? `GitHub (${selectedProjects.length}) ↗` : 'GitHub ↗'}
                  </a>
                ) : null}
              </div>
            )}

            {auditMode ? (
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '审计导航', en: 'Audit nav' })}</span>
                <button
                  type="button"
                  onClick={() => stepAuditGroup(-1)}
                  className="px-3 py-2 rounded-2xl text-xs font-extrabold border bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark transition-colors dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100"
                >
                  ← Prev
                </button>
                <button
                  type="button"
                  onClick={() => stepAuditGroup(1)}
                  className="px-3 py-2 rounded-2xl text-xs font-extrabold border bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark transition-colors dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100"
                >
                  Next →
                </button>
                <span className="text-[11px] font-black text-brand-text dark:text-slate-300">
                  {auditGroupIndex >= 0 ? `${auditGroupIndex + 1}/${ossGroups.length}` : `?/ ${ossGroups.length}`}
                </span>
              </div>
            ) : null}

            {!inLibrary && selectedProjects.length > 1 ? (
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '同组仓库', en: 'Grouped repos' })}</span>
                {selectedProjects.map((p) => (
                  <a
                    key={p.id}
                    href={p.repo}
                    target="_blank"
                    rel="noreferrer"
                    className="px-3 py-2 rounded-2xl text-xs font-extrabold border bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark transition-colors dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100"
                    title={p.label}
                  >
                    {shortenTag(repoNameFromUrl(p.repo) || p.id, 18)} ↗
                  </a>
                ))}
              </div>
            ) : null}

	          <div className="flex flex-wrap items-center gap-3">
	            <label className="flex items-center gap-2 text-xs font-extrabold text-brand-text dark:text-slate-300">
	              Accent
              <input
                type="color"
                value={accent}
                onChange={(e) => updateAccent(e.target.value)}
                className="h-9 w-12 rounded-xl border border-brand-textDark/20 bg-white p-1 dark:border-slate-700 dark:bg-slate-950"
                aria-label="accent-color"
              />
            </label>

              {inLibrary ? (
                <div className="flex flex-wrap items-center gap-2">
                  {ACCENT_PRESETS.map((p) => (
                    <button
                      key={p.id}
                      type="button"
                      onClick={() => updateAccent(p.value)}
                      className={`w-9 h-9 rounded-2xl border-2 transition-all ${
                        String(accent || '').toLowerCase() === String(p.value || '').toLowerCase()
                          ? 'border-brand-textDark shadow-[0_3px_0_#2D3436] dark:border-slate-100 dark:shadow-[0_3px_0_#e2e8f0]'
                          : 'border-brand-textDark/20 hover:border-brand-textDark/40 dark:border-slate-700 dark:hover:border-slate-500'
                      }`}
                      title={p.label}
                      aria-label={`accent-${p.id}`}
                      style={{ background: p.value }}
                    />
                  ))}
                </div>
              ) : null}

	            <label className="flex items-center gap-2 text-xs font-extrabold text-brand-text dark:text-slate-300">
	              {tx({ zh: '卡片缩放', en: 'Card scale' })}
	              <input
                type="range"
                min="0.6"
                max="1"
                step="0.05"
                value={cardScale}
                onChange={(e) => updateScale(e.target.value)}
                className="w-40"
                aria-label="card-scale"
              />
              <span className="tabular-nums text-brand-textDark/80 dark:text-slate-200">{cardScale.toFixed(2)}</span>
	            </label>

		            <button
		              type="button"
		              onClick={() => setPoke((v) => v + 1)}
		              data-testid="eyes-preview-poke"
		              className="ml-auto px-4 py-2 rounded-2xl bg-brand-textDark text-white text-xs font-extrabold hover:bg-brand-text transition-colors dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200"
		              title={tx({ zh: '触发一次动画自检（眨眼/扫视等）', en: 'Trigger a quick animation self-check (blink/look, etc.)' })}
		            >
	              {tx({ zh: 'Poke', en: 'Poke' })}
	            </button>
          </div>
        </div>
      </div>

      {inLibrary ? (
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-3">
            <div className="text-sm font-extrabold text-brand-textDark/80 dark:text-slate-200">{tx({ zh: '主用（3 套）', en: 'Primary (3 sets)' })}</div>
            <button
              type="button"
              onClick={() => updateView('compare')}
              className="text-xs font-extrabold text-brand-text hover:text-brand-textDark underline underline-offset-4 dark:text-slate-300 dark:hover:text-slate-100"
              title={tx({ zh: '切到对比视图', en: 'Open compare view' })}
            >
              {tx({ zh: '对比 ↗', en: 'Compare ↗' })}
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">{(pinnedLibraryProducts || []).map(renderLibraryProduct)}</div>

          {extraLibraryProducts.length ? (
            <>
              <div className="text-sm font-extrabold text-brand-textDark/80 dark:text-slate-200">{tx({ zh: '其他（追加在后）', en: 'More (appended)' })}</div>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                {extraLibraryProducts.map(renderLibraryProduct)}
              </div>
            </>
          ) : null}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {cards.map((card) => {
            const label = card.label
              ? tx(card.label)
              : (theme === 'ani' || theme === 'esp32' ? card.id : tx(emotionLabelEntry(card.id)))
            return (
              <FoilParallaxCard
                key={`${theme}-${variant || 'default'}-${card.id}`}
                data-testid="eyes-preview-card"
                className="border border-brand-textDark/10 bg-brand-surface dark:bg-slate-950 dark:border-slate-800"
              >
                <div className="px-5 py-4 border-b border-brand-textDark/10 flex items-center justify-between gap-3 dark:border-slate-800">
                  <div className="flex items-center gap-2 min-w-0">
                    <div className="text-2xl">{card.emoji}</div>
                    <div className="min-w-0">
                      <div className="text-brand-textDark dark:text-slate-100 font-extrabold truncate">{label}</div>
                      <div className="text-brand-text dark:text-slate-300 text-xs font-bold truncate">{card.subtitle}</div>
                    </div>
                  </div>
                  <span className="px-2 py-1 rounded-full text-[10px] font-black tracking-widest bg-brand-bg text-brand-textDark/80 border border-brand-textDark/10 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700">
                    {variant ? `${theme}:${variant}` : theme}
                  </span>
                </div>
                <div
                  className="p-4 flex justify-center"
                  data-testid="eyes-preview-screen"
                >
                  <div style={{ transform: `scale(${cardScale})`, transformOrigin: 'top center' }}>
                    <DeviceScreenPreview
                      theme={theme}
                      variant={variant || undefined}
                      emotion={card.emotion || 'neutral'}
                      expression={card.expression}
                      poke={poke}
                      accent={accent}
                      motionBoost
                    />
                  </div>
                </div>
              </FoilParallaxCard>
            )
          })}
        </div>
      )}
    </div>
  )
}
